// /**
//  * @file
//  * Attaches the behaviors for the main Menu component.
//  */
// !(function ($, Drupal) {
//   'use strict';

//   Drupal.behaviors.mainMenu = {
//     attach(context) {
//       const $mainMenu = $('.main-nav', context);
//       const isDesktop = window.matchMedia('(min-width: 992px)').matches;

//       // If there are no main menu elements within the context,
//       // none of the code below should execute.
//       if (!$mainMenu.length) {
//         return;
//       }

//       // Preserve the behavior.
//       const self = this;
//       const $toggle = $mainMenu.find('.item-level--0 > .main-nav__menu-link:not(href)');

//       $toggle.attr('aria-haspopup', 'true');
//       // $toggle.attr('aria-expanded', !state ? 'true' : 'false');

//       $toggle
//         .on('click', function () {
//           self.exposeChildren($(this));
//         })
//         .on('keypress', function (e) {
//           const keyCode = e.keyCode ? e.keyCode : e.which;
//           if (keyCode === 13) {
//             self.exposeChildren($(this));
//           }
//         })
//     },

//     exposeChildren($toggle) {
      
//       const $parent = $toggle.closest('.main-nav__menu-item');
//       const state = $parent.hasClass('expanded');
//       $('.main-nav__menu-item').removeClass('expanded');
//       $parent
//         .toggleClass('expanded', !state)
//         .find('> .main-nav__subnav')
//         .attr('aria-expanded', !state ? 'true' : 'false')
//     }
//   };
// })(jQuery, Drupal);

(function ($) {
  $(document).ready(function () {
    "use strict";

    /**
     * Accessible Menu
     * This file is based on content that is licensed according to the W3C Software License at
     * https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
     *
     * - 01 - Utility Functions
     * - 02 - MenuLink Class (Base)
     * - 03 - MenuButton Class (Extends MenuLink)
     * - 04 - Constants
     * - 05 - Initalize Menus
     * - 06 - Feature Items
     * - 07 - Menu Layout
     */

    /*------------------------------------*\
      - 01 - Utility Functions
      closeSearch seperate function to close search menu, can not be called in Classes
      searchNavigationControl contols search menu when button is clicked

      closeMobile seperate function to close mobile menu, can be called in Classes
      mobileMenuNavigationControl contols mobile menu when button is clicked
      Custom listener for if user has clicked away from menu
    \*------------------------------------*/

    // Close Search
    function closeSearch(key) {
      // Close Menu
      $("body").removeClass("js-prevent-scroll search");
      $(searchNavButton).removeClass("checked");
      $(searchNavButton).attr("aria-expanded", "false");

      // It was escape key, set focus
      if (key == "Esc" || key == "Escape") {
        $(searchNavButton).focus();
      }
    }

    // Mobile Navigation trigger function
    // This function mainly handles opening the menu & controlling menu access
    // The close function has been broken out into a seperate function
    function searchNavigationControl(event) {
      // Open Menu
      if ($(searchNavButton).attr("aria-expanded") === "false") {
        // Toggle overlay & checked classes
        $("body").addClass("js-prevent-scroll search");
        $(searchNavButton).addClass("checked");

        //Close mobile menu
        $(mobileNavButton).removeClass("checked");
        $(mobileNavButton).attr("aria-expanded", "false");

        // Open menu
        $(searchNavButton).attr("aria-expanded", "true");
      } else {
        closeSearch();
      }

      event.stopPropagation();
      event.preventDefault();
    }

    // Close menu
    function closeMobile(key) {
      // Close Menu
      $("body").removeClass("js-prevent-scroll search");
      $(mobileNavButton).removeClass("checked");
      $(mobileNavButton).attr("aria-expanded", "false");
      $(searchNavButton).removeClass("checked");
      $(searchNavButton).attr("aria-expanded", "false");

      // It was escape key, set focus
      if (key == "Esc" || key == "Escape") {
        $(mobileNavButton).focus();
      }
    }

    // Close menu
    function closeDesktop() {
      const mediaQuery = window.matchMedia("(min-width: 992px)");
      if (mediaQuery.matches) {
        // Close Menu
        $("body").removeClass("js-prevent-scroll search");
      }
    }
    // Mobile Navigation trigger function
    // This function mainly handles opening the menu & controlling menu access
    // The close function has been broken out into a seperate function
    function mobileMenuNavigationControl(event) {
      // Open Menu
      if ($(mobileNavButton).attr("aria-expanded") === "false") {
        // Toggle overlay & checked classes
        $("body").addClass("js-prevent-scroll");
        $(mobileNavButton).addClass("checked");

        //Close search menu
        $("body").removeClass("search");
        $(searchNavButton).removeClass("checked");
        $(searchNavButton).attr("aria-expanded", "false");

        // Open menu
        $(mobileNavButton).attr("aria-expanded", "true");
      } else {
        closeMobile();
      }

      event.stopPropagation();
      event.preventDefault();
    }

    // If a user clicks outside the menu, close menu
    // Stop events from continuning to information behind overlay
    $(window).on("click", function (e) {
      // Is the menu actually open?
      if ($("body").hasClass("js-prevent-scroll")) {
        let mainMenu = $(".nav-toggle-button");
        let searchBar = $(".search-toggle-button");

        // If we are on desktop, close menu if user clicks outside of menu
        const mediaQuery = window.matchMedia("(min-width: 992px)");
        if (mediaQuery.matches && !mainMenu[0].contains(e.target)) {
          closeDesktop();
        }

        // Is this the main menu?
        if (
          !mainMenu[0].contains(e.target) &&
          mainMenu.parent()[0] !== e.target &&
          mobileNavButton.attr("aria-expanded") === "true"
        ) {
          // Close Menus
          $("body").removeClass("js-prevent-scroll search");
          $(mobileNavButton).removeClass("checked");
          $(mobileNavButton).attr("aria-expanded", "false");

          // Stop event from traveling through to other components on the screen
          e.stopPropagation();
          e.preventDefault();
        }

        // Is this the search bar?
        if (
          !searchBar[0].contains(e.target) &&
          searchBar.parent()[0] !== e.target &&
          searchNavButton.attr("aria-expanded") === "true"
        ) {
          // Close Menus
          $("body").removeClass("js-prevent-scroll search");
          $(searchNavButton).removeClass("checked");
          $(searchNavButton).attr("aria-expanded", "false");
          // Stop event from traveling through to other components on the screen
          e.stopPropagation();
          e.preventDefault();
        }
      }
    });

    /*------------------------------------*\
      - 02 - MenuLink Class (Base)
      This is the base class for attaching functions to mobile menu links
    \*------------------------------------*/
    class MenuLinks {
      constructor(domNode) {
        this.domNode = domNode;
        this.menuitemNodes = [];
        this.firstMenuitem = false;
        this.lastMenuitem = false;

        let nodes = domNode.querySelectorAll(".main-nav__menu-link");

        for (let i = 0; i < nodes.length; i++) {
          let menuitem = nodes[i];

          this.menuitemNodes.push(menuitem);

          // menuitem.addEventListener(
          //   "keydown",
          //   this.onMenuitemKeydown.bind(this)
          // );

          if (!this.firstMenuitem) {
            this.firstMenuitem = menuitem;
          }
          this.lastMenuitem = menuitem;
        }
      }

      setFocusToMenuitem(newMenuitem) {
        this.menuitemNodes.forEach(function (item) {
          if (item === newMenuitem) {
            newMenuitem.focus();
          }
        });
      }

      setFocusToFirstMenuitem() {
        this.setFocusToMenuitem(this.firstMenuitem);
      }

      setFocusToLastMenuitem() {
        this.setFocusToMenuitem(this.lastMenuitem);
      }

      setFocusToPreviousMenuitem(currentMenuitem) {
        let newMenuitem, index;

        if (currentMenuitem === this.firstMenuitem) {
          newMenuitem = this.lastMenuitem;
        } else {
          index = this.menuitemNodes.indexOf(currentMenuitem);
          newMenuitem = this.menuitemNodes[index - 1];
        }

        this.setFocusToMenuitem(newMenuitem);

        return newMenuitem;
      }

      setFocusToNextMenuitem(currentMenuitem) {
        let newMenuitem, index;

        if (currentMenuitem === this.lastMenuitem) {
          newMenuitem = this.firstMenuitem;
        } else {
          index = this.menuitemNodes.indexOf(currentMenuitem);
          newMenuitem = this.menuitemNodes[index + 1];
        }
        this.setFocusToMenuitem(newMenuitem);

        return newMenuitem;
      }

      onMenuitemKeydown(event) {
        let target = event.currentTarget,
          key = event.key;

        if (event.ctrlKey || event.altKey || event.metaKey) {
          return;
        }

        switch (key) {
          case "Left":
          case "ArrowLeft":
            // Find the prevous element and set it as the focus
            let prev = $(target).parent().prev();
            if ($(prev).find(".main-nav__menu-link").length > 0) {
              //Move to previous element
              $(prev).find(".main-nav__menu-link").focus();
            } else {
              let prev = $(
                "ul.main-nav__menu.level--0 > .main-nav__menu-item > .main-nav__menu-link"
              );
              // Navigate to last list element
              prev[prev.length - 1].focus();
            }
            break;

          case "Right":
          case "ArrowRight":
            // Find the next element and set it as the focus
            let next = $(target).parent().next();
            if ($(next).find(".main-nav__menu-link").length > 0) {
              //Move to next element
              $(next).find(".menu__link").focus();
            } else {
              let next = $(
                "ul.main-nav__menu.level--0 > .main-nav__menu-item > .main-nav__menu-link"
              );
              // Wrap to first element in list
              next[0].focus();
            }
            break;

          case "Tab":
            // Did the user shift + tab?
            if (event.shiftKey) {
              let first = $(target).parent().is(":first-child");
              if (!first) {
                // Allow event to pass
              } else {
                this.closePopup();
              }
              break;
            } else {
              // Check if this is the last item in a list
              if ($(target).parent().is(":last-child")) {
                // Close menu
                closeMobile();
              }
            }
            break;

          case "Esc":
          case "Escape":
            // Close mobile menu
            closeMobile("Esc");
            break;

          default:
            break;
        }
      }
    }

    /*------------------------------------*\
      - 03 - MenuButton Class (Extends MenuLink)
      This is the base class for attaching functions to mobile menu links
    \*------------------------------------*/
    class MenuButtons extends MenuLinks {
      constructor(domNode) {
        //  Call parent constructor
        super(domNode);

        // Button specific properties
        this.buttonNode = domNode.querySelector("button");
        this.buttonNode.setAttribute("aria-expanded", "false");
        this.menuNode = domNode.querySelector("ul.main-nav__subnav.level--1");

        // Attach button specific event listeners
        this.buttonNode.addEventListener(
          "keydown",
          this.onButtonKeydown.bind(this)
        );
        this.buttonNode.addEventListener(
          "click",
          this.onButtonClick.bind(this)
        );

        this.menuitemNodes = [];
        this.firstMenuitem = false;
        this.lastMenuitem = false;

        let nodes = domNode.querySelectorAll("a.main-nav__menu-link");

        for (let i = 0; i < nodes.length; i++) {
          let menuitem = nodes[i];
          this.menuitemNodes.push(menuitem);

          menuitem.addEventListener(
            "keydown",
            this.onMenuitemKeydown.bind(this)
          );

          if (!this.firstMenuitem) {
            this.firstMenuitem = menuitem;
          }
          this.lastMenuitem = menuitem;
        }

        domNode.addEventListener("focusin", this.onFocusin.bind(this));
        domNode.addEventListener("focusout", this.onFocusout.bind(this));

        window.addEventListener(
          "mousedown",
          this.onBackgroundMousedown.bind(this),
          true
        );
      }

      // Popup menu methods
      openPopup() {
        // Incase search is open, close it
        if ($(searchNavButton).attr("aria-expanded") === "true") {
          $(searchNavButton).removeClass("checked");
          $(searchNavButton).attr("aria-expanded", "false");
        }

        this.menuNode.classList.add("open");
        $(this.menuNode).slideDown();
        // Attach open to parent menu for styles
        const parentMenu = $(this.menuNode).first().parent()[0];
        parentMenu.classList.add("expanded");
        this.buttonNode.setAttribute("aria-expanded", "true");
        this.menuNode.setAttribute("aria-expanded", "true");

        // Are we on desktop?
        const mediaQuery = window.matchMedia("(min-width: 768px)");
        if (mediaQuery.matches) {
          // Toggle overlay & checked classes
          $("body").addClass("js-prevent-scroll");
        }
      }

      closePopup() {
        if (this.isOpen()) {
          this.buttonNode.setAttribute("aria-expanded", "false");
          this.menuNode.setAttribute("aria-expanded", "false");
          this.menuNode.classList.remove("open");
          $(this.menuNode).slideUp();
          // Attach open to parent menu for styles
          const parentMenu = $(this.menuNode).first().parent()[0];
          parentMenu.classList.remove("expanded");
        }
      }

      isOpen() {
        return this.buttonNode.getAttribute("aria-expanded") === "true";
      }

      // Menu event handlers
      onFocusin() {
        this.domNode.classList.add("focus");
      }

      onFocusout() {
        this.domNode.classList.remove("focus");
      }

      onButtonKeydown(event) {
        let key = event.key,
          flag = false;
        switch (key) {
          case " ":
          case "Enter":
            if (this.isOpen()) {
              this.closePopup();
              this.buttonNode.focus();
              flag = true;

              // Remove scroll lock on desktop
              closeDesktop();
              break;
            } else {
              this.openPopup();
              flag = true;
              break;
            }

          case "Down":
          case "ArrowDown":
            if (this.isOpen()) {
              super.setFocusToFirstMenuitem();
            } else {
              this.openPopup();
              flag = true;
            }
            break;

          case "Esc":
          case "Escape":
            // If a button is open,close it
            if (this.isOpen()) {
              this.closePopup();
              this.buttonNode.focus();
              flag = true;
            }
            // Close mobile menu;
            closeMobile("Esc");
            break;

          case "Up":
          case "ArrowUp":
            this.openPopup();
            super.setFocusToLastMenuitem();
            flag = true;
            break;

          case "Left":
          case "ArrowLeft":
            // Find prevous element and set it as the focus
            let prev = $(this.buttonNode).parent().prev();
            if ($(prev).find(".main-nav__menu-link").length > 0) {
              //Move to previous element
              $(prev).find(".main-nav__menu-link").focus();
            } else {
              // We need to account for hidden menu items that could be in the list
              let prev = $(
                "ul.main-nav__menu.level--0 > .main-nav__menu-item:not(:hidden) > .main-nav__menu-link"
              );
              // Navigate to last list element
              prev[prev.length - 1].focus();
            }
            break;

          case "Right":
          case "ArrowRight":
            // Find next element and set it as the focus
            let next = $(this.buttonNode).parent().next();
            if ($(next).find(".main-nav__menu-link").length > 0) {
              //Move to next element
              $(next).find(".main-nav__menu-link").focus();
            } else {
              let next = $(
                "ul.main-nav__menu.level--0 > .main-nav__menu-item > .main-nav__menu-link"
              );
              // Wrap to first element in list
              next[0].focus();
            }
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      onButtonClick(event) {
        if (this.isOpen()) {
          this.closePopup();
          this.buttonNode.focus();

          // Remove scroll lock on desktop
          closeDesktop();
        } else {
          this.openPopup();
        }

        event.stopPropagation();
        event.preventDefault();
      }

      onMenuitemKeydown(event) {
        let target = event.currentTarget,
          key = event.key,
          flag = false;

        if (event.ctrlKey || event.altKey || event.metaKey) {
          return;
        }

        switch (key) {
          case "Esc":
          case "Escape":
            if (this.isOpen) {
              this.closePopup();
              this.buttonNode.focus();
              flag = true;
              // Remove scroll lock on desktop
              closeDesktop();
            } else {
              closeMobile("Esc");
            }
            break;

          case "Up":
          case "ArrowUp":
            super.setFocusToPreviousMenuitem(target);
            flag = true;
            break;

          case "ArrowDown":
          case "Down":
            super.setFocusToNextMenuitem(target);
            flag = true;
            break;

          case "Left":
          case "ArrowLeft":
            // Close menu if open
            if (this.isOpen()) {
              this.closePopup();
            }

            // Find the top level button prevous element and set it as the focus
            let prev = $(target)
              .closest("ul.main-nav__menu.level--0 > .main-nav__menu-item.expanded")
              .prev();
            if ($(prev).find(".menu__link").length > 0) {
              //Move to previous element
              $(prev).find(".menu__link").focus();
            } else {
              let prev = $(
                "ul.main-nav__menu.level--0 > .main-nav__menu-item > .main-nav__menu-link"
              );
              // Navigate to last list element
              prev[prev.length - 1].focus();
            }
            break;

          case "Right":
          case "ArrowRight":
            // Close menu if open
            if (this.isOpen()) {
              this.closePopup();
            }
            // Find the top level button next element and set it as the focus
            let next = $(target)
              .closest("ul.main-nav__subnav.level--1 > .main-nav__menu-item.expanded")
              .next();

            if ($(next).find(".main-nav__menu-link").length > 0) {
              //Move to next element
              $(next).find(".main-nav__menu-link").focus();
            } else {
              let next = $(
                "ul.main-nav__menu.level--0 > .main-nav__menu-item > .main-nav__menu-link"
              );
              // Wrap to first element in list
              next[0].focus();
            }
            break;

          case "Home":
          case "PageUp":
            this.setFocusToFirstMenuitem();
            flag = true;
            break;

          case "End":
          case "PageDown":
            super.setFocusToLastMenuitem();
            flag = true;
            break;

          case "Tab":
            // Did the user shift + tab?
            if (event.shiftKey) {
              let first = $(target).parent().is(":first-child");
              // Account for expanded menus with no toggle
              let expanded = $(target)
                .parent()
                .parent()
                .parent()
                .hasClass("expanded");
              if (this.isOpen() && (!first || expanded)) {
                // Allow event to pass
              } else {
                // Remove scroll lock on desktop
                closeDesktop();

                this.closePopup();
              }
              break;
            } else {
              // Check if this is the last item in top level menu
              let menuLast = $(target)
                .closest("ul.main-nav__subnav.level--1")
                .find("> li:last-child");

              // If the last menu item is a submenu, find the last item in the submenu
              if (menuLast.hasClass("expanded")) {
                menuLast = menuLast.find("ul > li:last-child > a");
              } else {
                menuLast = menuLast.find("> a");
              }

              // Confirm if this is the last item in the menu
              let last = $(target).is(menuLast);

              if (this.isOpen() && !last) {
                // If the event is open, or is not the last in the list allow event to pass
              } else {
                this.closePopup();
              }
            }
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      // If user clicks away, close menu
      onBackgroundMousedown(event) {
        if (!this.domNode.contains(event.target)) {
          if (this.isOpen()) {
            this.closePopup();
            this.buttonNode.focus();
          }
        }
      }
    }

    /*------------------------------------*\
      - 04 - Constants
    \*------------------------------------*/

    // Main Menu Items
    const mainMenuItems = document.querySelectorAll(
      ".main-nav__menu.level--0 > li"
    );

    // Initialize mobile menu button & nav
    const mobileNavButton = $(".nav-toggle-button");

    // Initialize mobile menu button & nav
    const searchNavButton = $(".search-toggle-button");
    const searchBar = $("#searchControl");

    /*------------------------------------*\
      - 05 - Initalize Menus
      What items should these functions be attached to
      @todo Rework menu section for better load times & clarity
    \*------------------------------------*/

    function initalizeMenus() {
      // Initialize main menu list
      for (let i = 0; i < mainMenuItems.length; i++) {
        // Attach different class based on button or link
        if (mainMenuItems[i].querySelector("button")) {
          new MenuButtons(mainMenuItems[i]);
          // Initialize top level submenus as hidden
          $(mainMenuItems[i])
            .find("ul.main-nav__subnav.level--1")
            .attr("style", "display:none");
        } else {
          // new MenuLinks(mainMenuItems[i]);
        }
      }
    }

    // Attach mobile menu button listener controls
    mobileNavButton.on("click", mobileMenuNavigationControl);
    searchNavButton.on("click", searchNavigationControl);

    // Attach search bar listener controls
    searchBar.on("keydown", function (event) {
      if (event.key == "Esc" || event.key == "Escape") {
        closeSearch(event.key);
      }
    });

    // Configure menus on load
    initalizeMenus();
  });
})(jQuery);

(function ($, Drupal) {
  Drupal.behaviors.ariaControls = {
    attach: function (context) {
      once("ariaControls", "ul.main-nav__nav", context).forEach(function (
        menu
      ) {
        // Find top level menu buttons
        const buttons = $(menu).find(
          "ul.main-nav__menu.level--0 > li > button.main-nav__menu-link"
        );
        // Add aria controls for buttons & related submenus
        // For each primary level for main menu, attach aria label
        buttons.each(function () {
          const id = $(this).text().toLowerCase().replace(/\s/g, "");
          $(this)
            .attr("aria-haspopup", "true")
            .attr("aria-controls", `panel-${id}`)
            .next()
            .attr("id", `panel-${id}`)
            .attr("aria-label", $(this).text());
        });
      });
    },
  };
})(jQuery, Drupal);
